import React from 'react'
import classnames from 'classnames'
import firebase from 'firebase/app'
import Button from '../Button'
import S from './Login.module.css'
import 'firebase/auth'

const PageAction = {
  SHOW_FORM : 'SF',
  TRY_LOGIN : 'TL',
  TRY_PWDRESET : 'TPR',
}

class Login extends React.Component {

  constructor( props ) {
    super( props ) // props = { setLoading, createdNewUser, errorContext: {getErrorCode(), setErrorCode()} }
    this._isMounted = false;
    const { email } = this.props;
    this.state = {
      email : email || '',
      password : '',
      action : PageAction.SHOW_FORM,
      resettingPassword : false,
    }
  }

  componentDidMount() {
    this._isMounted = true;
    this.focusInit();
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  focusInit = () => {
    const { email, password } = this.state;
    if ( !email ) {
      this.emailInput.focus();
    } else if ( !password ) {
      this.passwordInput.focus();
    } else {
      this.loginButton.focus();
    }
  }

  doSignIn = () => {
    const { email, password } = this.state;
    const { errorContext, setLoading } = this.props;
    console.log( 'Signing in for', email );
    firebase.auth().signInWithEmailAndPassword( email, password )
      .then( () => {
        console.log( 'Signed in', email, '! ' );
        return null;
      } )
      .catch( ( e ) => {
        console.error( 'Error signing in for', email );
        errorContext.setErrorCode( e.code );
      } )
      .finally( () => {
        if ( this._isMounted ) {
          this.setState( { action : PageAction.SHOW_FORM } )
        }
        setLoading( false )
      } );
  }

  signIn = () => {
    const { errorContext, setLoading } = this.props;
    setLoading( true, 'Signing in...' );
    errorContext.setErrorCode( undefined );
    this.setState( { action : PageAction.TRY_LOGIN }, this.doSignIn );
  }

  doResetPassword = () => {
    const { email } = this.state;
    const { errorContext, setLoading } = this.props;
    console.log( 'Sending reset email...' );
    firebase.auth().sendPasswordResetEmail( email )
      .then( () => {
        console.log( 'Email sent to', email, '!' );
        if ( this._isMounted ) {
          this.setState( { action : PageAction.SHOW_FORM } );
        }
        return null
      } )
      .catch( ( e ) => {
        console.error( 'Error sending reset email' );
        errorContext.setErrorCode( e.code );
      } )
      .finally( () => {
        setLoading( false );
      } );
  }

  resetPassword = () => {
    const { errorContext, setLoading } = this.props;
    setLoading( true, 'Sending password reset email...' );
    errorContext.setErrorCode( undefined );
    this.setState( { action : PageAction.TRY_PWDRESET, resettingPassword : true }, this.doResetPassword );
  }

  onChangeEmail = ( evt ) => {
    const { errorContext } = this.props;
    errorContext.setErrorCode( undefined );
    this.setState( { email : evt.target.value, resettingPassword : false } )
  }

  onChangePassword = ( evt ) => {
    const { errorContext } = this.props;
    errorContext.setErrorCode( undefined );
    this.setState( { password : evt.target.value, resettingPassword : false } )
  }

  getErrorDiv = () => {
    const { resettingPassword } = this.state;
    const { errorContext, createdNewUser, email } = this.props;
    const errorCode = errorContext.getErrorCode();
    let text = '';
    if ( errorCode ) {
      switch ( errorCode ) {
        case 'auth/invalid-email':
          text = 'Error: Invalid email address';
          break;
        case 'func/unavailable':
          text = 'Subscription service is currently unavailable.'
          break;
        default:
          if ( !resettingPassword ) {
            text = 'Error: Invalid email/password';
          }
          break;
      }
    }
    let classes = classnames( S.inputRow, S.message );
    if ( text.length > 0 ) {
      classes = classnames( S.inputRow, S.message, S.error );
    } else if ( resettingPassword ) {
      text = 'Password reset email sent.';
    } else if ( createdNewUser ) {
      text = (
        // eslint-disable-next-line react/jsx-one-expression-per-line
        <span>Created user <em>{email}</em>.</span>
      )
    }
    return (
      <div className={classes}>
        {text}
      </div>
    );
  }

  render() {
    const {
      email,
      password,
      action,
    } = this.state

    return (
      <div>
        {this.getErrorDiv()}
        <div className={S.inputRow}>
          <label className={S.label} htmlFor="txtEmail">
            Email
          </label>
          <input
            className={S.input}
            type="text"
            onChange={this.onChangeEmail}
            value={email}
            title={email ? '' : 'Enter your email'}
            disabled={action !== PageAction.SHOW_FORM}
            ref={( ref ) => { this.emailInput = ref }}
            id="txtEmail"
          />
        </div>
        <div className={S.inputRow}>
          <label className={S.label} htmlFor="pwdPassword">
            Password
          </label>
          <input
            className={S.input}
            type="password"
            onChange={this.onChangePassword}
            value={password}
            title={password ? '' : 'Enter your password'}
            disabled={action !== PageAction.SHOW_FORM}
            ref={( ref ) => { this.passwordInput = ref }}
            id="pwdPassword"
          />
        </div>
        <div className={S.buttons}>
          <Button
            scheme="primary"
            onClick={this.signIn}
            disabled={action !== PageAction.SHOW_FORM && !( email && password )}
            title={email && password ? 'Login' : 'Enter your email address and password.'}
            ref={( ref ) => { this.loginButton = ref }}
          >
            Login
          </Button>
          <Button
            scheme="link"
            onClick={this.resetPassword}
            disabled={action !== PageAction.SHOW_FORM && !email}
            title={!email ? 'Enter your email address to reset the password.' : 'Reset Password'}
          >
            Reset Password
          </Button>
        </div>
      </div>
    );
  }
}

/** Wrap it */
export default Login
